export const MAX_NUMBER_OF_RESOURCES = 50;

export type IEventResource = {
  _id: string;
  authorId: string;
  dateCreated: string;
  resourceSpec: {
    file: { name: string; downloadUrl: string; contentType: string };
  };
};
